// extracted by mini-css-extract-plugin
export default {"info":"_0HEx6","date":"y4-1w","number":"Dhh7C"};